import { render, staticRenderFns } from "./AdminServiceCreate.vue?vue&type=template&id=6497ed74"
import script from "./AdminServiceCreate.vue?vue&type=script&lang=js"
export * from "./AdminServiceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports